import {
	Component,
	Input
} from '@angular/core';

import { VideogularComponent } from '../Videogular.Component';

import styles from './VgSeek.Component.module.less';

@Component({
	selector: 'vg-seek',
	host: {
		'[class]': 'styles.root'
	},
	template: `
		<button
			type="button"
			[attr.aria-label]="isBackward ? translations.skipBack10Sec : translations.skipForward10Sec"
			[ngClass]="[
				styles.button,
				isBackward ? 'vb-icon-backward-10' : 'vb-icon-forward-10'
			]"
			[tooltip]="isBackward ? translations.skipBack10Sec : translations.skipForward10Sec"
			[placement]="'top'"
			vbControlBarFocus
			[disableControlBarFocus]="disableControlBarFocus"
			(click)="vgApi.seek10Secs(!isBackward)">
		</button>
	`
})
export class VgSeekComponent {
	@Input() public translations: any;
	@Input() public isBackward: boolean;
	@Input() public disableControlBarFocus: boolean;

	public readonly styles = styles;

	constructor(
		public vgApi: VideogularComponent
	) {}
}
